<template>
	<div id="Integrations">
		<div
			v-if="apis_integration.length == 0 || isLoading == true"
			class="row text-center"
		>
			<div class="col">
				<div class="spinner-grow" role="status">
					<span class="sr-only">Carregando...</span>
				</div>
			</div>
		</div>
		<div v-else class="total-api-list">
			<div class="api-list scroll-custom" v-if="isLoading == false">
				<div
					v-for="(item, index) in normalizeApis"
					:key="item.index"
					class="item-api-list center-align"
				>
					<div
						:class="item.list_class"
						@click.prevent="goAPI(index, item.api_name)"
					>
						<p
							class="user--avatar m-0"
							v-if="item.profile_data != null"
						>
							<img :src="item.profile_data.data.picture" alt />
						</p>
						<p class="logo-api" v-else>
							<img :src="item.api_icon" alt />
						</p>
						<p>{{ item.api_name }}</p>
					</div>
					<span
						v-if="item.api_connect"
						class="font-14 confirm-conect text-dark opacity-50"
						@click="disconectApi(item.api_name)"
						>Remover</span
					>
					<span
						v-else
						class="font-14 confirm-disconect"
						@click.prevent="goAPI(index, item.api_name)"
						>Conectar</span
					>
				</div>
			</div>
		</div>
		<div class="false-step" v-if="this.falseStep">
			<div class="container">
				<div class="row no-gutters justify-content-between py-3 mb-3">
					<div class="col align-self-center text-left">
						<span class="back-btn">
							<i
								@click="closeFalseStep()"
								class="fas fa-chevron-left"
							></i>
						</span>
					</div>
				</div>
				<div class="row">
					<div class="col-12 py-5 mb-4 text-left">
						<h4>{{ normalizeApiMessage }}</h4>
						<p>{{ normalizeApiSubtitle }}</p>
					</div>
				</div>
				<div class="row align-items-center">
					<div
						class="col-auto py-2 mb-5 px-0"
						v-if="
							this.activeApi == 'insta' ||
							this.activeApi == 'instagram'
						"
					>
						<span>@</span>
					</div>
					<div class="col py-2 mb-5 pl-1">
						<input
							type="text"
							class="form-control"
							@keyup.enter="handleUser"
							placeholder="username"
							v-model="userSocialMedia"
							v-if="
								this.activeApi == 'insta' ||
								this.activeApi == 'instagram'
							"
						/>
						<input
							type="text"
							class="form-control"
							@keyup.enter="handleUser"
							placeholder="Url do canal"
							v-model="userSocialMedia"
							v-else
						/>
					</div>
				</div>
				<div class="row justify-content-center text-center">
					<div class="col-10 col-lg-6 mb-5">
						<button
							class="btn btn-primario btn-large"
							:disabled="loadingIcon"
							@click="handleUser"
						>
							Continuar
							<i
								v-if="loadingIcon"
								class="fas fa-spinner fa-spin"
							></i>
						</button>
					</div>
					<div class="w-100"></div>
					<div
						class="col-10 col-lg-6 mb-4"
						v-if="activeApi == 'insta'"
					>
						<p class="my-3 subtext">Ou</p>
					</div>
					<div class="w-100"></div>
					<div class="col-10 col-lg-6" v-if="activeApi == 'insta'">
						<span
							class="instagram-api-link"
							@click="originalInstagram()"
							>Continuar com Instagram</span
						>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			ref="modalProfiles"
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="d-block text-left mb-5">
				<div class="row">
					<div class="col-12 mb-2">
						<h5>Escolha a página</h5>
					</div>
					<div
						class="col-12 col-md-6 card-profile"
						v-for="(profile, index) in pagesProfileFacebook"
						:key="index"
					>
						<div
							class="card text-center"
							@click="
								updateTokenFacebook(profile.id, profile.name)
							"
						>
							<div class="cover-image">
								<img :src="profile.cover" alt />
							</div>
							<p>
								<img
									:src="profile.picture"
									class="rounded-circle profile-avatar"
									alt
								/>
							</p>
							<p>
								<strong>{{ profile.name }}</strong>
							</p>
							<p>
								<span v-if="profile.likes" class="like-count">
									<i class="far fa-thumbs-up"></i>
									{{ profile.likes }}
								</span>
								<span v-if="profile.rating" class="rate-count">
									<i class="fas fa-star"></i>
									{{ profile.rating }}
								</span>
							</p>
						</div>
						<div class="row"></div>
					</div>
					<div class="col-12 text-center personal-profile" v-if="this.facebookPages.api_name == 'Facebook'">	
						<span @click="usePersonalProfile"
							>Usar perfil pessoal -
							{{ personalProfileName }}</span
						>
					</div>
					<div class="loading-modal" v-if="loadingModal">
						<span>
							<i class="fas fa-spinner fa-spin"></i>
						</span>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal centered ref="InstaShup" hide-header hide-footer size="sm">
			<div class="d-block text-left">
				<div class="row pt-4">
					<div class="col-12 text-center mb-2" v-if="exhibitionName">
						<p class="title--modal">É você?</p>
					</div>
					<div class="col-12 text-center mb-3">
						<div v-if="avatarInstashup.length > 0">
							<img
								:src="avatarInstashup"
								alt
								class="avatar-instachup rounded-circle"
							/>
						</div>
						<img
							v-else
							src="../assets/img/user-not-found.png"
							alt
							class="avatar-instachup"
						/>
					</div>
					<div class="col-12 text-center mb-3" v-if="exhibitionName">
						<p
							class="exhibition--name"
							:class="{ minimize: exhibitionName.length > 11 }"
						>
							{{ returnArroba }}{{ exhibitionName }}
						</p>
					</div>
					<div
						class="col-12 text-center mb-5"
						v-if="errors.length > 0"
					>
						<p v-for="erro in errors" :key="erro">{{ erro }}</p>
					</div>
				</div>
				<div class="row pb-4" v-if="privateProfile == true">
					<div class="col-12 text-center mb-3">
						<button
							class="btn btn-primario btn-large"
							@click.prevent="handleResetUser()"
						>
							Voltar
						</button>
					</div>
				</div>
				<div class="row pb-4" v-else>
					<div v-if="avatarInstashup" class="col-12 text-center mb-2">
						<button
							class="btn btn-primario btn-large mb-2"
							@click.prevent="confirmInstagram()"
						>
							Sim, sou eu
						</button>
					</div>
					<div
						v-if="avatarInstashup"
						class="col-12 text-center mb-3 subtext"
					>
						<span
							@click="handleResetUser()"
							class="simple-link ghost--link"
							>Não sou eu, voltar</span
						>
						<p class="my-3 font-12">
							Ao clicar em sim, você aceita os Termos de Uso, e
							confirma que é de sua propriedade o perfil
						</p>
					</div>
					<div v-else class="col-12 text-center mb-5">
						<button
							class="btn btn-primario btn-large"
							@click.prevent="handleResetUser()"
						>
							Voltar
						</button>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
	import axios from "axios";
	export default {
		name: "Integrations",
		data() {
			return {
				isLoading: false,
				ROOT_API: null,
				emailUser: null,
				falseStep: false,
				loadingIcon: false,
				mainName: "",
				avatarInstashup: "",
				userSocialMedia: "",
				exhibitionName: "",
				privateProfile: null,
				errors: [],
				apis_integration: [],
				facebookPages: {
					api_name:"",
				},
				apisConnecteds: 0,
				loadingModal: false,
				activeApi: null,
			};
		},
		props: {
			siteId: {
				type: Number,
				required: true,
			},
		},
		methods: {
			loadIntegrations,
			checkFacebookConnection,
			goAPI,
			disconectApi,
			showModal,
			hideModal,
			updateTokenFacebook,
			handleUser,
			handleUserInstashup,
			handleUserYoutube,
			handleConfirmUser,
			handleResetUser,
			originalInstagram,
			closeFalseStep,
			normalizeAvatar,
			confirmInstagram,
			usePersonalProfile,
		},
		watch: {
			apisConnecteds() {
				this.$emit("hasConnection", this.apisConnecteds);
			},
			facebookPages() {
				if (
					this.facebookPages.api_connect == 1 &&
					this.facebookPages.using_account == null
				) {
					if (this.facebookPages.sub_accounts.length > 1) {
						this.showModal();
					}
				}
			},
		},
		computed: {
			returnArroba() {
				if (this.activeApi == "insta" || this.activeApi == "instagram") {
					return "@";
				} else {
					return "";
				}
			},
			normalizeApis: function () {
				let apisNormalized = this.apis_integration;
				return apisNormalized.filter((api) => api.api_id > 0);
			},
			normalizeApiMessage() {
				if (this.activeApi == "insta" || this.activeApi == "instagram") {
					return "Entre com o usuário do Instagram.";
				} else {
					return "Qual o link do seu canal?";
				}
			},
			normalizeApiSubtitle() {
				if (this.activeApi == "insta" || this.activeApi == "instagram") {
					return "Coloque o perfil que tem conteúdos relevantes para criar seu site.";
				} else {
					return "Vamos buscar os conteúdos do seu canal.";
				}
			},
			personalProfileName() {
				if (this.facebookPages.sub_accounts.length > 0) {
					let test = this.facebookPages.sub_accounts.find(
						(profile) => profile.profile == 1
					);
					return test.name;
				}
				return '';
			},
			pagesProfileFacebook() {
				let pagesFacebook;
				if (this.facebookPages.sub_accounts) {
					pagesFacebook = this.facebookPages.sub_accounts.filter(
						(page) => page.profile == 0
					);
					return pagesFacebook;
				}
			},
		},
		created() {
			this.ROOT_API = process.env.ROOT_API;
			this.emailUser = this.$session.get("userEmail");
			this.loadIntegrations();
		},
	};
	function usePersonalProfile() {
		let profilePage;
		if (this.facebookPages.sub_accounts) {
			profilePage = this.facebookPages.sub_accounts.find(
				(page) => page.profile == 1
			);
		}
		this.updateTokenFacebook(profilePage.id, profilePage.name);
	}
	function handleUser() {
		this.errors = [];
		this.exhibitionName = this.userSocialMedia;
		if (this.userSocialMedia.length >= 1) {
			if (this.activeApi == "insta" || this.activeApi == "instagram") {
				this.handleUserInstashup();
			} else if (this.activeApi == "youtube") {
				this.handleUserYoutube();
			}
		}
	}
	function handleUserInstashup() {
		this.userSocialMedia = this.userSocialMedia.replace("@", "");
		this.userSocialMedia = this.userSocialMedia.replace(" ", "");
		this.userSocialMedia = this.userSocialMedia.replace("/?hl=pt-br", "");
		this.userSocialMedia = this.userSocialMedia.replace(
			"https://www.instagram.com/",
			""
		);
		this.userSocialMedia = this.userSocialMedia.replace("/", "");
		this.userSocialMedia = this.userSocialMedia.trim();
		this.handleConfirmUser("insta");
	}
	function handleUserYoutube() {
		this.userSocialMedia = this.userSocialMedia.trim();
		this.userSocialMedia = this.userSocialMedia.replace("/featured/", "");
		this.userSocialMedia = this.userSocialMedia.replace("/featured", "");
		let youtubeName = this.userSocialMedia.split("/");
		this.userSocialMedia = youtubeName[youtubeName.length - 1];
		if (this.userSocialMedia == "") {
			this.userSocialMedia = youtubeName[youtubeName.length - 2];
		}
		this.userSocialMedia = this.userSocialMedia.replace(/ /g, "");
		this.userSocialMedia = this.userSocialMedia.replace(
			"?view_as=subscriber",
			""
		);
		this.handleConfirmUser("youtube");
	}
	function handleConfirmUser(api) {
		this.avatarInstashup = "";
		this.loadingIcon = true;
		let token = this.$session.get("jwt");
		axios({
			method: "get",
			url: `${this.ROOT_API}/api/site/${this.siteId}/profile/${api}?username=${this.userSocialMedia}`,
			data: "",
			headers: {
				Authorization: "Bearer " + token,
				"Content-Type": "application/x-www-form-urlencoded",
			},
		})
			.then((response) => {
				if (response.data.content == false) {
					this.errors.push("Ops! Usuário não encontrado");
					this.$refs.InstaShup.show();
					this.loadingIcon = false;
				} else {
					if (response.data.content.status == 1) {
						this.avatarInstashup = response.data.content.picture;
						this.mainName = response.data.content.name;
						this.loadingIcon = false;
						if (api == "insta") {
							window.localStorage.setItem(
								"InstagramSegment",
								response.data.content.segment
							);
						} else {
							this.exhibitionName = response.data.content.name;
						}
						if (response.data.content.private === true) {
							this.privateProfile = true;
							this.errors.push(
								"Usuário com perfil privado. Em seu Instagram acesse Configurações > Privacidade > Privacidade da conta e desabilite a privacidade"
							);
						} else {
							this.privateProfile = false;
						}
						this.$refs.InstaShup.show();
					}
				}
			})
			.catch((response) => {
				this.errors.push("Ops! Usuário não encontrado");
				this.$refs.InstaShup.show();
				this.loadingIcon = false;
			});
	}
	function handleResetUser() {
		this.mainName = "";
		this.$refs.InstaShup.hide();
	}
	function loadIntegrations() {
		this.apis_integration = [];
		this.apisConnecteds = 0;
		let token = this.$session.get("jwt");
		axios({
			method: "get",
			url: this.ROOT_API + "/api/site/" + this.siteId + "/verify",
			timeout: 0,
			headers: {
				Authorization: "Bearer " + token,
				"Content-Type": "application/x-www-form-urlencoded",
			},
		})
			.then((response) => {
				this.apis_integration = Object.keys(
					response.data.apis_integration
				).map((key) => {
					return response.data.apis_integration[key];
				});
				this.apis_integration.forEach((api) => {
					if (api.api_connect == 1) {
						this.apisConnecteds += 1;
					}
				});
				this.checkFacebookConnection();
			})
			.catch(function (response) {
				console.log(response);
			});
	}
	function checkFacebookConnection() {
		let facebook;
		facebook = this.apis_integration.find((api) => api.api_name == "Facebook");
		if (facebook && facebook.api_connect === 1) {
			this.facebookPages = facebook;
		}
	}
	function goAPI(index, api) {
		// IDENTIFICA A API E ENVIA O USUÁRIO PARA FAZER AUTENTICAÇÃO
		api = api.toLowerCase();
		this.activeApi = api;
		if (this.apis_integration[index].api_connect == 0) {
			if (api === "instagram" || api === "insta" || api === "youtube") {
				this.falseStep = true;
			} else {
				window.location.replace(
					`${this.ROOT_API}/connect/${api}/${this.siteId}`
				);
			}
		}
	}
	function showModal() {
		this.$refs.modalProfiles.show();
	}
	function hideModal() {
		this.$refs.modalProfiles.hide();
	}
	function updateTokenFacebook(profileId, profileName) {
		this.mainName = profileName;
		this.loadingModal = true;
		let totalData = new FormData();
		totalData.append("id", profileId);
		let token = this.$session.get("jwt");
		axios({
			method: "post",
			url:
				this.ROOT_API +
				"/api/site/" +
				this.siteId +
				"/integration/facebook/update",
			data: totalData,
			headers: {
				Authorization: "Bearer " + token,
				"Content-Type": "application/x-www-form-urlencoded",
			},
		})
			.then((response) => {
				this.apis_integration = Object.keys(
					response.data.apis_integration
				).map((key) => {
					return response.data.apis_integration[key];
				});
				this.hideModal();
				this.loadingModal = false;
			})
			.catch(function (response) {
				console.log("Erro ao atualizar facebook token");
				this.loadingModal = false;
			});
	}
	function originalInstagram() {
		window.location.replace(
			this.ROOT_API + "/connect/instagram/" + this.siteId
		);
	}
	function closeFalseStep() {
		this.userSocialMedia = "";
		this.avatarInstashup = "";
		this.falseStep = false;
	}
	function normalizeAvatar() {
		if (this.avatarInstashup != "") {
			return this.avatarInstashup;
		} else {
			return "../assets/img/user-not-found.png";
		}
	}
	function confirmInstagram() {
		let api = this.activeApi;
		this.loadingIcon = true;
		if (api == "instagram") api = "insta";
		this.$refs.InstaShup.hide();
		let totalData = "";
		let token = this.$session.get("jwt");
		axios({
			method: "post",
			url: `${this.ROOT_API}/api/site/${this.siteId}/profile/create/${api}?username=${this.userSocialMedia}`,
			data: totalData,
			headers: {
				Authorization: "Bearer " + token,
				"Content-Type": "application/x-www-form-urlencoded",
			},
		})
			.then((response) => {
				if (response.data.status == 1) {
					this.loadIntegrations();
					this.closeFalseStep();
				}
				this.loadingIcon = false;
			})
			.catch(function (response) {
				console.log("Erro ao salvar instagram2");
				this.hideModal();
				this.loadingIcon = false;
			});
	}
	function disconectApi(api) {
		this.isLoading = true;
		api = api.toLowerCase();
		let totalData = "";
		let token = this.$session.get("jwt");
		axios({
			method: "post",
			url: this.ROOT_API + "/api/site/" + this.siteId + "/disconnect/" + api,
			data: totalData,
			headers: {
				Authorization: "Bearer " + token,
				"Content-Type": "application/x-www-form-urlencoded",
			},
		})
			.then((response) => {
				this.apisConnecteds--;
				this.isLoading = false;
				this.loadIntegrations();
			})
			.catch(function (response) {
				console.log("Erro ao desconectar API");
			});
	}
</script>
<style scoped>
	.title--modal {
		font-family: "Montserrat", sans-serif;
		font-size: 1.5rem;
		font-weight: 700;
		margin: 0;
	}
	.exhibition--name {
		font-family: "Montserrat", sans-serif;
		font-size: 1.5rem;
		margin: 0;
	}
	.ghost--link {
		color: #c8c8c8;
		font-family: "Montserrat", sans-serif;
	}
	.font-12 {
		font-size: 12px;
	}
	.card-profile {
		margin: 0 0 15px;
	}
	.card-profile .card {
		padding-bottom: 5px;
		cursor: pointer;
		height: 170px;
	}
	.card-profile img {
		width: 65px;
		height: 65px;
	}
	.card-profile p {
		margin: 4px;
	}
	.card-profile .cover-image img {
		width: 100%;
		object-fit: cover;
		background-color: #3b5998;
	}
	.card-profile .profile-avatar {
		margin-top: -45px;
		border: 3px solid var(--main-color);
	}
	.card-profile .like-count,
	.card-profile .rate-count {
		width: 45%;
		display: inline-block;
	}
	.card-profile .like-count i,
	.card-profile .rate-count i {
		color: var(--main-color);
	}
	.personal-profile {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #3b5998;
		color: #fff;
		padding: 10px 5px;
	}
	.personal-profile span {
		cursor: pointer;
		font-size: 0.8rem;
	}
	.alert-instashup {
		color: red;
		font-weight: 400;
	}
	.false-step {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background-color: rgb(255, 255, 255);
		z-index: 4;
		overflow: auto;
		padding-bottom: 30px;
	}
	.instagram-api-link {
		color: var(--main-color);
	}
	.border-instachup {
		background-image: linear-gradient(to bottom, #ffb300, #d51ec0);
		padding: 4px;
		display: inline-block;
		border-radius: 70px;
	}
	.avatar-instachup {
		width: 130px;
		height: 130px;
	}
	.minimize {
		font-size: 16px;
	}
	.loading-modal {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background-color: #ccccccc7;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.loading-modal span {
		font-size: 2rem;
		color: var(--main-color);
	}
</style>



// WEBPACK FOOTER //
// src/components/Integrations.vue